export default __webpack_public_path__ + "static/media/kbbi.02c9dfc4.png";